import "./App.scss";

// Components
import Footer from "./components/Footer/Footer.jsx";
import Navbar from "./components/Navbar/Navbar.jsx";
import TeamNav from "./components/Navbar_Team/Navbar.jsx";

// Pages
import Errorpage from "./pages/Errorpage/Errorpage.jsx";
import { Switch, Route } from "react-router-dom";
import Team from "./pages/Teampage/Team.jsx";
import FAQ from "./pages/faq/FAQ.jsx";
import Homepage from "./pages/Homepage/Homepage.jsx";
import Recruitment from "./pages/Recruitment/Recuitment25.jsx";
import Gallery from "./pages/Gallery/Gallery.js";
import Supportus from "./pages/Support-Us/support-us.jsx";
// import Newgallery from "./pages/Gallery/newgallery.js";

function App() {
  return (
    <div className="App">
      <Switch>
        <Route
          exact
          path="/recruitment_form"
          component={() => {
            window.location.href = "https://docs.google.com/forms/d/1r1nexVtQ3gLNgGtHWoS1eE4b6wF8GCDRCY-bPuQEHuA/closedform";
            return null;
          }}
        />
        <Route exact path={"/"}>
          <Navbar />
          <Homepage />
        </Route>

        <Route exact path={"/team"}>
          <Navbar />
          <Team />
        </Route>

        <Route exact path={"/team/:year"} children={<Team />}></Route>
        
        <Route exact path={"/recruitment"}>
          <Navbar />
          <Recruitment />
        </Route> 
          
        <Route exact path={"/gallery"}>
          <Navbar />
          <Gallery />
        </Route>

        <Route exact path={"/support-us"}>
        <TeamNav />
          <Supportus />
        </Route>
        
        <Route exact path={"/faq"}>
          <Navbar />
          <FAQ />
        </Route>

        <Route exact path={"/*"}>
          <Navbar />
          <Errorpage />
        </Route>

      </Switch>

      <Footer />
    </div>
  );
}

export default App;
